import { createRoot } from 'react-dom/client';
import { AiAssistButton } from './components/AiAssistButton';

const renderFormAi = () => {
  const el = document.getElementById('form-ai_assist');
  const moduleContracted = el.dataset.module_contracted && el.dataset.module_contracted === 'true';

  if (el !== null) {
    const root = createRoot(el);
    root.render(<AiAssistButton moduleContracted={moduleContracted} />);
  }
};

export default renderFormAi;
